import { render, staticRenderFns } from "./PolipectomiaEndoscopicaIntestinoCrassoEdit.vue?vue&type=template&id=13e4b25d"
import script from "./PolipectomiaEndoscopicaIntestinoCrassoEdit.vue?vue&type=script&lang=js"
export * from "./PolipectomiaEndoscopicaIntestinoCrassoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports